import { render } from "./ElectionPolicy.vue?vue&type=template&id=439cd24c&ts=true"
import script from "./ElectionPolicy.vue?vue&type=script&lang=ts"
export * from "./ElectionPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__